import React, {useState, useEffect} from 'react';
import { SiteLink } from '../../components';
import { useStore } from '../../store';

import { FaChevronDown } from 'react-icons/fa';
import { useAuth } from '../../auth/index'
//import { SearchBar } from './searchBar';

export function NavBar(props) {
  const open = props.open;
  //const currentLocation = props.currentLocation;
  const { state } = useStore();
  const _useAuth = useAuth();

  const menu = state.menu || { items: [] };

  const currentLocation = state.history && state.history.length > 0? state.history[state.history.length - 1].path : '';
  const depth = 1;
  const menuItemElts = menu.items.map((item, index) => {
    if (item.title === "MEMBERS' LOG IN") {
      // Check both session types for authentication
      const isAuthenticated = (_useAuth.session && !_useAuth.session.expired()) || 
                             (_useAuth.sessionV2 && !_useAuth.sessionV2.expired());
      
      if (isAuthenticated) {
        return (
          <li className="navBar__item" key="logout">
            <SiteLink
              className="navBar__link"
              to="/"
              onClick={() => {
                props.onCloseMenu();
                // Use signoutAdmin to clear both session types
                _useAuth.signoutAdmin();
                if (currentLocation === '/') {
                  window.location.reload(false);
                }
              }}
            >
              <span>MEMBERS' LOG OUT</span>
            </SiteLink>
          </li>
        );
      } else {
        return (
          <li className="navBar__item" key={index}>
            <SiteLink
              className="navBar__link"
              to={item.url}
              onClick={props.onCloseMenu}
            >
              <span>{item.title}</span>
            </SiteLink>
          </li>
        );
      }
    }
    return (
      <MenuItem
        item={item}
        key={index}
        depth={depth}
        onCloseMenu={props.onCloseMenu}
        currentLocation={currentLocation}
        _useAusth={_useAuth}
      />
    );
  });
  
  return (
    <div className={`navBar ${open ? 'navBar--on' : ''}`} id="sliding-menu">
      {/* <SearchBar onCloseMenu={props.onCloseMenu}/> */}
      <div className="navBar__scrollArea" id="top-menu">
        <nav className="navBar_nav">
          <ul>
            {menuItemElts}
          </ul>
        </nav>
      </div>
    </div>);

}

function MenuItem(props) {
  const [subMenuOpened, setSubMenuOpened] = useState(false);
  const item = props.item;
  const subItems = item.items || [];
  const currentLocation = props.currentLocation;

  const subItemsElts = subItems.length > 0? subItems.map((subItem, index) =>
    <SubMenuItem item={subItem} key={index} onCloseMenu={props.onCloseMenu} />
  ) : null;


  useEffect(() => {
    //console.log('navbar', currentLocation);
    setSubMenuOpened(false);
  }, [currentLocation])

  function closeMenu() {
    props.onCloseMenu();
  }

  function toggleSubmenu(e) {
    e.preventDefault();
    e.stopPropagation();
    setSubMenuOpened(!subMenuOpened);
  }

  return (
    <li className={`navBar__item ${subMenuOpened ? 'navBar__item--open' : ''}`}>
      <SiteLink className="navBar__link" to={item.url} onClick={() => closeMenu()}>
        <span>{item.title}</span>
        {subItemsElts && <span className="navBar__icon" onClick={(e) => toggleSubmenu(e)}><FaChevronDown /></span>}
      </SiteLink>
      {subItemsElts &&
        <ul className={`navBar__subMenu`}>
          {subItemsElts}
        </ul>}
    </li>
  )
}

function SubMenuItem(props) {
  const item = props.item;
  function closeMenu() {
    props.onCloseMenu();
  }

  return (
    <li className="navBar__subItem">
      <SiteLink className="navBar__subLink" to={item.url} onClick={() => closeMenu()}>
        <span>{item.title}</span>
      </SiteLink>
    </li>
  )
}